export type CurrencyCode = 'DZD';

export interface CurrencyInfo {
  code: CurrencyCode;
  name_ar: string;
  name_en: string;
  name_fr: string;
  symbol: string;
  rate: number;
}

export const currencies: CurrencyInfo[] = [
  { code: 'DZD', name_ar: 'دينار جزائري', name_en: 'Algerian Dinar', name_fr: 'Dinar Algérien', symbol: 'د.ج', rate: 1 },
];

export const getCurrency = (code: CurrencyCode): CurrencyInfo => {
  return currencies[0];
};

export const convertPrice = (priceInDZD: number, targetCurrency: CurrencyCode): number => {
  return priceInDZD;
};

export const formatPrice = (priceInDZD: number, currencyCode: CurrencyCode): string => {
  return `${priceInDZD} د.ج`;
};
